<template lang="pug">
  .product-block
    .product-block-info
      .img-container
        img(
          v-lazy="product.sqImg"
          )
        .img-container-tag
          img(:src="require('@/assets/img/flag_cover_24h.svg')",v-if="showTag_24h()")
      .title {{product.title}}
      a(:href="product.url",target="_blank")
    .product-tag(v-if="badge")
      img(
        src="@/assets/img/badge_discount.svg",
        v-if="this.tagIndex() == 0"
        )
      img(
        src="@/assets/img/badge_take.svg",
        v-else-if="this.tagIndex()==1"
      )
      img(
        src="@/assets/img/badge_instant.svg",
        v-else-if="this.tagIndex()==2"
      )
      img(
        src="@/assets/img/badge_hotsale.svg",
        v-else-if="this.tagIndex()==3"
      )
    .product-block-pricing(v-if="!loading")
      .price-initial(v-if="initial") {{product.origPrice}}
      .price
        .notranslate.number
          span $
          |{{product.price}}
        .number-tail(v-if="product.priceTail") {{product.priceTail}}
    .product-block-function(v-if="!loading")
      .type-1(v-if="type===1")
        .ic-sm
          //愛心底框
          img(src="@/assets/icons/ic_favorite_2.svg")
          //實心紅愛心
          img(
            src="@/assets/icons/ic_favorite_2_full.svg",
            v-if="favoriteTemp",
            :class="{'zoom-out':favoriteOut,'heart-beat':favoriteIn}")
          .touch-area(
            @click="verifyFavorite(product.id)",
            )
        .bought
          p
            span {{product.salesVolume}}
            |人已購買
      .type-3(v-else-if="type===1")
    .product-block-mask(v-if="loading")
      img(
        src="@/assets/img/preload_placeholder_lg.gif",
        v-if="loading"
      )
  
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {swiper,swiperSlide} from 'vue-awesome-swiper'
export default {
  name: 'ads-carousel',
  components:{
    swiper,
    swiperSlide
  },
  props:{
    loading:{
      type: Boolean,
      default: true,
      require: false
    },
    // 商品物件
    product: Object,
    // 是否顯示原價
    initial:{
      type: Boolean,
      default: true,
      require: false
    },
    // 為哪一型商品卡片
    type:{
      type: Number,
      default: 0,
      require: false
    },
    // 是否顯示折數
    discount:{
      type: Boolean,
      default: false,
      require: false
    },
    // 是否顯示標籤
    badge:{
      type: Boolean,
      default: false,
    },
    isAuthenticated:{
      type: Boolean,
      required: false,
      default: false
    },
  },
  data(){
    return{
      tagNumber: null,
      tagNumberTest: null,
      tagList:[
        'discount',
        'take',
        'instant',
        'hotsale'
      ],
      favoriteOut: false,
      favoriteIn: false,
      favoriteTemp: false,
    }
  },
  methods: {
    // 加入最愛
    addFavorite(){
      this.favoriteIn = true
      setTimeout(()=>{
        this.favoriteIn = false
      },1000)
    },
    // 移除最愛
    removeFavorite(){
      this.favoriteOut = true
      setTimeout(()=>{
        this.favoriteOut = false
      },600)
    },
    // 檢驗最愛
    verifyFavorite(bid){
      if(this.isAuthenticated){
        if(this.favoriteTemp){
          this.removeFavorite();
          setTimeout(()=>{
            this.favoriteTemp = false
          },600)
        }else if(!this.favoriteTemp){
          this.favoriteTemp = true
          this.addFavorite();
        }
        
        // 延遲送出變更
        let _this = this
        setTimeout(function(){
          let status = {
            bid: bid,
            collect: _this.favoriteTemp
          }
          _this.$emit('clickFavorite',status);
          // console.log(status)
        },600)
      }else{
        this.$emit('clickFavorite',false)
      }
    },
    // 標籤分類
    tagIndex(){
      let newIndex = null
      if(this.product.icons[0]){
        this.tagNumber = this.product.icons[0].style
        let tagNumber = this.tagNumber
        if(tagNumber == 11){
          newIndex = 0; //折價
        }else if(tagNumber == 12){
          newIndex = 1; //超取
        }else if(tagNumber == 3){
          newIndex = 2; //即用
        }else if(tagNumber == 1){
          newIndex = 3; //熱銷
        }else{
          // 不知道要給什麼所以給100
          newIndex = 100
        }
      }else{
        // 不知道要給什麼所以給100
        newIndex = 100
      }
      
      return newIndex
    },
    showTag_24h(){
      if(this.product.categories){
        let tempArray = this.product.categories.filter(element=>parseInt(element)==3000);
        if(tempArray.length!=0){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
      
    }
  },
  computed:{
    
  },
  mounted(){
  },
  watch:{
    product(){
      this.favoriteTemp = this.product.inCollect
    }
  }
}
</script>

<style lang="scss">
  
</style>
